const styles = () => ({
  singleItem: {
    paddingBottom: 15,
    padding: 0,
    display: 'block',
    backgroundColor: 'white',
  },
  vc_wrapper: {
    position: 'relative',
    zIndex: '2',
  },
  overFlowHidden: {
    overflow: 'hidden',
  },

});
export default styles;



// WEBPACK FOOTER //
// ./src/containers/VisualConversationFeed/styles.js